import { FONTS } from 'constants/styleVariables';
import React, { useState } from 'react';
import styled from 'styled-components';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipBox = styled.div`
  height: 36px;
  background-color: #E65847;
  color: #F5F5F5;
  font-size: 16px;
  font-family: ${FONTS.poppins};
  font-weight: 600;
  padding: 6px 12px 10px 12px;
  border-radius: 8px;
  position: absolute;
  z-index: 10;
  width: max-content;
  max-width: 200px;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
  ${props => props.position === 'top' && `
    bottom: calc(100% + 15px);
    left: 50%;
    transform: translateX(-50%);
  `}

  ${props => props.position === 'right' && `
    top: 50%;
    left: calc(100% + 15px);
    transform: translateY(-50%);
  `}

  ${props => props.position === 'bottom' && `
    top: calc(100% + 15px);
    left: 50%;
    transform: translateX(-50%);
  `}

  ${props => props.position === 'left' && `
    top: 50%;
    right: calc(100% + 15px);
    transform: translateY(-50%);
  `}
`;

const TooltipArrow = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  border-style: solid;
  z-index: 1;

  ${props => props.position === 'top' && ` //DE MODIFICAT
    border-width: 5px 5px 0 5px;
    border-color: #E65847 transparent transparent transparent;
    top: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(2px);
  `}

  ${props => props.position === 'right' && `
    border-width: 7px 9px 7px 0;
    border-color: transparent #E65847 transparent transparent;
    top: 50%;
    right: -18px;
    transform: translateY(-50%) translateX(-2px);
  `}

  ${props => props.position === 'bottom' && ` //DE MODIFICAT
    border-width: 0 5px 5px 5px;
    border-color: transparent transparent #E65847 transparent;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-2px);
  `}

  ${props => props.position === 'left' && ` //DE MODIFICAT
    border-width: 5px 0 5px 5px;
    border-color: transparent transparent transparent #E65847;
    top: 50%;
    right: 0;
    transform: translateY(-50%) translateX(2px);
  `}
`;

const StyledTooltip = ({ children, tooltipText, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <TooltipContainer onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      {isVisible && (
        <>
          <TooltipBox position={position}>
            {tooltipText}
          </TooltipBox>
          <TooltipArrow position={position} />
        </>
      )}
      {children}
    </TooltipContainer>
  );
};

export default StyledTooltip;
